module.exports = __webpack_public_path__ + "static/media/kitchen-dark.d976d218.jpg";